import { useEffect, useState } from 'react';

import { isClientWidthAbove } from 'src/modules/responsive-helpers';

interface UseHoustonAdProps {
  minimumClientWidth: number;
}

const useHoustonAd = ({ minimumClientWidth }: UseHoustonAdProps) => {
  const [shouldRenderAdverts, setShouldRenderAdverts] = useState(
    isClientWidthAbove(minimumClientWidth),
  );

  useEffect(() => {
    if (isClientWidthAbove(minimumClientWidth) && !shouldRenderAdverts) {
      setShouldRenderAdverts(true);
    }
  }, [shouldRenderAdverts, minimumClientWidth]);

  return {
    shouldRenderAdverts,
  };
};

export default useHoustonAd;
